import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import { withStyles } from '@material-ui/core/styles';
import classnames from "classnames";

const styles = {
  networkAndLoginContainer: {
    backgroundColor: "#fff",
    marginBottom: 32,
    width: "100%",
    padding: 24,
    boxSizing: "border-box",
    textAlign: "center",
  },
  collage: {
    maxWidth: "100%",
    width: 384,
  },
  loginPrompt: {
    fontSize: 24,
    maxWidth: 400,

    b: {
      fontWeight: 700,
    }
  },
  largeLoginButton: {
    display: "inline-block",
    padding: "1em 5em",
    fontSize: 18,
    lineHeight: 1.5,
  },
};

class NetworkAndLogin extends React.Component {
  constructor(){
    super();
    this.state = {
    dropOpen: false,
  };
  this.toggleDropdownMenu = this.toggleDropdownMenu.bind(this);
  this.hideDropdownMenu = this.hideDropdownMenu.bind(this);
  };
  toggleDropdownMenu(event) {
    event.preventDefault();
    this.setState({ dropOpen: true }, () => {
    document.addEventListener('click', this.hideDropdownMenu);
    });
  }

  hideDropdownMenu() {
    this.setState({ dropOpen: false }, () => {
      document.removeEventListener('click', this.hideDropdownMenu);
    });
  }
  render() {
    const {classes, metadata, metadata: {network_base_url, network_and_login_enabled, network_and_login, multiple_institutes, institute_list}} = this.props;
    var collage_url = "";
    if(metadata.collage){
      collage_url = metadata.collage.url;
    }

    const collage = (<img src={collage_url} className={classes.collage} alt="collage"/>);

    const loginContent = (
      <div style={{padding: 12}}>
        <Grid container direction="column" spacing={24} justify="center" alignItems="center">
          <Grid item>
            <div className={classes.loginPrompt}>
              <b>Search</b> and <b>Network</b> with alums across programs and batches
            </div>
          </Grid>
          {multiple_institutes ?(
          <Grid item className = "dropdown" style = {{padding: 0}}>
            <div className = {classnames("drop_button", classes.largeLoginButton)} onClick = {this.toggleDropdownMenu}>Select Institute/Login</div>
              {this.state.dropOpen ? (
                <ul className = "drop_ul">{institute_list.map((inst, index)=>(
                  <a className = "drop_a" href = {inst.url}><li className = "drop_li">{inst.name}</li></a>))}
                </ul>
              ): (null)
            }
          </Grid>
          ):
            (
              <Grid item>
                <a href={network_base_url} className={classnames("ac_button", classes.largeLoginButton)}>
                  Login/Signup
                </a>
              </Grid>
            )
          }
          <Grid item>
            <span className="text_caption_light">
              Powered by <a href="https://www.almaconnect.com/" className="ac_link">AlmaConnect</a>
            </span>
          </Grid>
        </Grid>
      </div>
    );

    return (
      <Paper className={classes.networkAndLoginContainer}>
        <div style={{padding: 12}}>
          <Grid container direction="row" spacing={24} justify="center" alignItems="center">
            <Grid item>
              {collage}
            </Grid>
            <Grid item>
              {loginContent}
            </Grid>
          </Grid>
        </div>
      </Paper>
    );
  }
}



NetworkAndLogin.propTypes = {
  metadata: PropTypes.shape({
    networkBaseUrl: PropTypes.string.isRequired,
    networkAndLogin: PropTypes.shape({
      enabled: PropTypes.bool,
      college: PropTypes.string,
    }).isRequired,
  }).isRequired
};

export default withStyles(styles)(NetworkAndLogin);
